var en_us = {
    values: {
        to: 'to',
        Apply: 'Apply',
        fleet: 'Fleet',
        moving: 'moving',
        Stop: 'Stop',
        Hide: 'Hide',
        stopped: 'stopped',
        Trips: 'Trips',
        trips: 'trips',
        speed: 'speed',
        Speed: 'Speed',
        back: 'go back',
        Back: 'Go Back',
        Search: 'Search',
        Default: 'Default',
        Distance: 'Distance',
        Duration: 'Duration',
        Satellite: 'Satellite',
        Transit: 'Transit',
        Schedules: 'Schedules',
        Itineraries: 'Itineraries',
        'Options': 'Options',
        'On Going': 'On Going',
        'View Settings': 'View Settings',
        'View': 'View',
        'Path Information': 'Path Information',
        'Map type': 'Map type',
        'Map details': 'Map details',
        'until now': 'until now',
        'Load More': 'Load More',
        'last trips': 'last trips',
        'Remove All': 'Remove All',
        disconnected: 'disconnected',
        'View positions report': 'View positions report',
        'Total Trips': 'Total Trips',
        'in progress': 'in progress',
        'Driver Name': 'Driver Name',
        'slow running': 'slow running',
        'Vehicle Name': 'Vehicle Name',
        'All Vehicles': 'All Vehicles',
        'Vehicle Trips': 'Vehicle Trips',
        'Most Updated': 'Most Updated',
        'Less Updated': 'Less Updated',
        'Timespan Information': 'Timespan Information',
        'Trip Information': 'Trip Information',
        'Moving First': 'Moving First',
        'Stopped First': 'Stopped First',
        'Remove marker': 'Remove marker',
        'Average Velocity': 'Average Velocity',
        'Average Speed': 'Average Speed',
        'Speed (Km/h)': 'Speed (Km/h)',
        'Based on timespan': 'Based on timespan',
        'Based on timestamp': 'Based on timestamp',
        'Disconnected First': 'Disconnected First',
        'Search for a place': 'Search for a place',
        'Based on Selected trip': 'Based on Selected trip',
        'Vehicle Speed Variation': 'Vehicle Speed Variation',
        'View Vehicle History': 'View Vehicle History',
        'There is no trip for the selected timespan': 'There is no trip for the selected timespan',
        'Select another timespam to view informations': 'Select another timespam to view informations',
        'There are no results for your search.': 'There are no results for your search.',
        'Redo your search to view the information.': 'Redo your search to view the information.',
        'There are no trips for the selected period.': 'There are no trips for the selected period.',
        'Select another period to view the information.': 'Select another period to view the information.',
        'View all POIs':'View all POIs',
        'Filter by groups':'Filter by groups',
        'Discard changes': 'Discard changes'
    }
}

// {   id: SORT_STOPED_FIRST,  value: 'Parados Primeiro', },
// {   id: SORT_DISCONNECT_FIRST,  value: 'Desconectados Primeiro', }

module.exports = en_us
